import React, { useContext, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Link, useHistory, useLocation } from 'react-router-dom';
import firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from '../../firebaseConfig';
import { NewUserContext, UserContext } from '../../App';
import Alert from '@material-ui/lab/Alert';


if(firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
}));

export default function Signup() {
  const history = useHistory();
  const location = useLocation();
  let { from } = location.state || { from: { pathname: "/" } };
  const [loggedInUser, setLoggedInUser] = useContext(UserContext)
  const [newUser, setNewUser] = useContext(NewUserContext)
  const [error, setError] = useState('')
  const classes = useStyles();
  const passwordRef = useRef();
    
  const handleBlur = (e) => {
    let isField;
    if(e.target.name === 'email'){
      setError('')
      isField = /\S+@\S+\.\S+/.test(e.target.value) || setError('Please provide a valid email')
    }
    else if(e.target.name === 'password') {
      setError('')
      isField = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/.test(
        e.target.value) || setError('Password should contain at least 8 characters, one uppercase letter and one number')
    }
    else if(e.target.name === 'confirmPass') {
      setError('')
      isField = e.target.value === passwordRef.current.value || setError("Password didn't match");
    }
    if(isField) {
      setLoggedInUser({...loggedInUser, [e.target.name]: e.target.value})
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    firebase.auth().createUserWithEmailAndPassword(loggedInUser.email, loggedInUser.password)
  .then((userCredential) => {
    var user = userCredential.user;
    setNewUser(false)
    setLoggedInUser(user)
    history.replace(from);

  })
  .catch((error) => {
    setError('')
    var errorMessage = error.message;
    setError(errorMessage)
  });
  }

  return (
    <div className="text-center">
      <img src={require('../../images/logo.png').default} alt="" style={{width: '300px', marginTop: '50px'}}/>
      <form className={classes.root} noValidate autoComplete="off" className="d-flex flex-column justify-content-center align-items-center" onSubmit={handleSubmit}>
        {error && <Alert severity="error" style={{width: '400px', marginTop: '20px'}}>{error}</Alert>}
      <TextField  label="Name" variant="filled" color="secondary" style={{width: '400px', marginTop: '80px', marginBottom: '20px'}} required/>
      <TextField  label="Email" variant="filled" color="secondary" style={{width: '400px', marginBottom: '20px'}} name="email" onBlur={handleBlur} required/>
      <TextField  label="Password" variant="filled" color="secondary" style={{width: '400px', marginBottom: '20px'}} name="password" onBlur={handleBlur} required type="password" ref={passwordRef}/>
      <TextField id="filled-basic" label="Confirm Password" variant="filled" color="secondary" style={{width: '400px', marginBottom: '20px'}} name="confirmPass" onBlur={handleBlur} required type="password"/>
      <Button variant="contained" color="secondary" style={{width: '400px', height: '50px'}} className="mb-2" type="submit">
        Sign up
      </Button>     
    </form>
    <Link to='/login' style={{color: '#DC0095'}}><p>Already have an account</p></Link> 
    </div>
  );
}